import {Component, OnInit, Inject, ViewEncapsulation, OnDestroy} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbAppEvents } from '@irb-common/events';
import { ImportOrdersResultGridLayoutService } from './import-orders-result.grid-layout.service';
import {InventoryService} from '../inventory/inventory.service';
import {IAlertDialogData} from "@irb/app.model";

@Component({ standalone: false,
  selector: 'irb-import-orders-result-dialog',
  templateUrl: './import-orders-result-dialog.component.html',
  styleUrls: ['./import-orders-result-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportOrdersResultDialogComponent implements OnInit, OnDestroy {
  grid: any;
  gridOptions: any;
  progressTimer: any = null;
  updateStatusCount = 0;
  isUiTest = false;
  frameworkComponents: any;

  constructor(
      public dialogRef: MatDialogRef<ImportOrdersResultDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public as: AppService,
      private gls: ImportOrdersResultGridLayoutService,
      public pfs: InventoryService
  ) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
  }

orderImportSaveTempSecCheckIntervalStart(statusId: any, type: string, validRecords: any) {
  this.pfs.saveTempSecAsyncStatus(statusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {
          const response = statusResponse?.responseData;
          const reqStatus = response?.reqStatus?.trim().toUpperCase();
          if (reqStatus === 'FAILED') {
              this.actionStatusCheckFailed();
          }

          if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
              this.updateProgressBarStatus(response, type, validRecords);
          }
          if (reqStatus === 'COMPLETED') {
              this.insertImportOrders(validRecords);
          }
      } else {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        if(this.progressTimer) clearTimeout(this.progressTimer);
      }
  }, () => {
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    if(this.progressTimer) clearTimeout(this.progressTimer);
  });
}

insertImportOrders(validRecords: any) {
  this.pfs.insertImportedOrdersAsync(validRecords, this.data.currentTab).subscribe((data: any) => {
    if(this.progressTimer) clearTimeout(this.progressTimer);
      if (data.responseStatus === "SUCCESS") {
          this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
          this.orderImportInsertCheckIntervalStart(data.responseUtilityMap.statusId, 'INSERT_ORDERS', null);
      } else {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: 'error',
              summary: 'Import Orders',
              detail: " An error occurred processing your request."
          });
      }
  });
}

saveTempSecurities() {
  if(this.data.nonInventoriedSecurities && this.data.nonInventoriedSecurities.length > 0){
    this.pfs.saveTempSecuritiesAsync(this.data.nonInventoriedSecurities).subscribe((data: any) => {
      if(this.progressTimer) clearTimeout(this.progressTimer);
      if(data.responseStatus === "SUCCESS") {
          this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
          this.orderImportSaveTempSecCheckIntervalStart(data.responseUtilityMap.statusId, 'SAVE_TEMP_SECURITIES', this.data.validRecords);
      } else {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: 'error',
              summary: 'Import Orders',
              detail: " An error occurred processing your request."
          });
      }
  });
  } else {
    this.insertImportOrders(this.data.validRecords); 
  }
  this.close();
}

  completeImport() { 

    if(this.data.nonInventoriedSecurities && this.data.nonInventoriedSecurities.length > 0){
      this.pfs.saveTempSecurities(this.data.nonInventoriedSecurities).subscribe((data: any) => { 
        if(data.responseStatus === "SUCCESS") { 
        }else{
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Import Orders',
            detail: " An error occurred processing your request."
          });
        }
      });
    }


    this.pfs.insertImportedOrdersAsync(this.data.validRecords, this.data.currentTab).subscribe((data: any) => {
      if(this.progressTimer) clearTimeout(this.progressTimer);
      if (data.responseStatus === "SUCCESS") {
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
        this.orderImportInsertCheckIntervalStart(data.responseUtilityMap.statusId, 'INSERT_ORDERS', null);
      } else {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'error',
          summary: 'Import Orders',
          detail: " An error occurred processing your request."
        });
      }
    });

    this.close();
  }
  updateProgressBarStatus(response: any, type: string, validRecords: any) {
    let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
    if (this.isUiTest)
        timeout = 0;
    this.updateStatusCount++;
    this.progressTimer = setTimeout(() => {
        if (type === 'SAVE_TEMP_SECURITIES') {
            this.orderImportSaveTempSecCheckIntervalStart(response.statusId, type, validRecords);
        } 
        if (type === 'INSERT_ORDERS') {
            this.orderImportInsertCheckIntervalStart(response.statusId, type, validRecords);
        }
    }, timeout);
}

orderImportInsertCheckIntervalStart(statusId: any, type: string, validRecords: any) {
  this.pfs.insertImportOrdersAsyncStatus(statusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {
          const response = statusResponse.responseData;
          const reqStatus = response.reqStatus.trim().toUpperCase();
          if (reqStatus === 'FAILED') {
              if (response.failMsg && response.failMsg.toUpperCase() === 'STALEDATAEXCEPTION')
                  this.showStaleDataDialog();
              else
                  this.actionStatusCheckFailed();

              this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          }

          if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
              this.updateProgressBarStatus(response, type, validRecords);
          }
          if (reqStatus === 'COMPLETED') {
              this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
              if (this.progressTimer) clearTimeout(this.progressTimer);
              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                  severity: 'success',
                  summary: 'Import Orders',
                  detail: response.successRecCount + " orders imported/updated."
              });
              this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
          }
      } else if (statusResponse.responseStatus === "EXCEPTION") {
          this.actionStatusCheckFailed();
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      } else {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          if (this.progressTimer) clearTimeout(this.progressTimer);
      }
  }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      if (this.progressTimer) clearTimeout(this.progressTimer);
  });
}

  actionStatusCheckIntervalStart(statusId: any, type: string, validRecords: any) {
    this.pfs.actionStatusCheck(statusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {
        const response = statusResponse.responseData;
        const reqStatus = response.reqStatus.trim().toUpperCase();
        if (reqStatus === 'FAILED') {
          if (response.failMsg && response.failMsg.toUpperCase() === 'STALEDATAEXCEPTION')
            this.showStaleDataDialog();
          else
            this.actionStatusCheckFailed();

          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        }

        if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
          this.updateProgressBarStatus(response, type, validRecords);
        }
        if (reqStatus === 'COMPLETED') {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          if(this.progressTimer) clearTimeout(this.progressTimer);
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'success',
            summary: 'Import Orders',
            detail: response.successRecCount + " orders imported/updated."
          });
          this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
        }
      } else {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        if(this.progressTimer) clearTimeout(this.progressTimer);
      }
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      if(this.progressTimer) clearTimeout(this.progressTimer);
    });
  }

  actionStatusCheckFailed() {
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    this.close();
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dType: 'ERROR',
      dTitle: '',
      dProceedBtnLabel: '',
      msg: 'An error occurred processing your request.',
      onProceed: () => {
      }
    } as IAlertDialogData);
  }

  showStaleDataDialog() {
    this.close();
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dTitle: 'Refresh Required',
      dProceedBtnLabel: 'Refresh',
      msg: "You are attempting to import orders which were modified by another user. Please refresh page to see latest changes.",
      onProceed: () => {
        this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
      }
    });
  }

  ngOnDestroy() {
    if(this.progressTimer) clearTimeout(this.progressTimer);
  }
}
